import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EMPTY, Subscription } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { SatisfactionConfigService } from 'src/app/services/satisfaction-services/satisfaction-config-service/satisfaction-config.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-satisfaction-config-comments-card',
  templateUrl: './satisfaction-config-comments-card.component.html',
  styleUrls: ['./satisfaction-config-comments-card.component.scss']
})
export class SatisfactionConfigCommentsCardComponent implements OnInit, OnChanges {

  @Input() active;
  updateSatisfactionsCommentsSubscription: Subscription;

  basicDataForm = new FormGroup({
    active: new FormControl(null, Validators.required)
  });

  constructor(private satisfactionConfigService: SatisfactionConfigService,
              private snackbarService: SnackBarService) {}

  ngOnInit() {}

  ngOnChanges() {
    if ((this.active === true) || (this.active === false)) {
      this.resetForm();
    }
  }

  public submitForm(e) {
    this.updateSatisfactionsCommentsSubscription = this.satisfactionConfigService.updateSatisfactionConfigComments(this.basicDataForm.get('active').value).pipe(
      tap(o => this.satisfactionConfigService.refreshSatisfactionsConfig()),
      catchError(error => {
        this.snackbarService.open(error['data']['error'], 'error');
        this.satisfactionConfigService.refreshSatisfactionsConfig();
        return EMPTY; })
    ).subscribe();
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      active: this.active
    });
  }

}
